module.exports = __webpack_public_path__ + "img/logo_login.94697f0c.png";